"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    altTextAndroid: 'Get it on Google Play',
    altTextIos: 'Download on the App Store'
  },
  fr: {
    altTextAndroid: 'Disponible sur Google Play',
    altTextIos: 'Télécharger dans l’App Store'
  }
};